import { Injectable } from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {getSelfAssessedRequirements} from "../store/selectors/user.selector";
import {ProfessionPreview} from "../interfaces/profession-preview";
import {SelfAssessedReqRow} from "../interfaces/self-assessed-req-row";
import {ProfessionDetails} from "../interfaces/profession-details";

@Injectable({
  providedIn: 'root'
})
export class ProfessionUserMatchingService {

  selfAssessedRequirements: SelfAssessedReqRow[] = new Array(0);

  constructor(
    private store: Store<AppState>
  ) {
    this.store.select(getSelfAssessedRequirements()).subscribe((requirements) => {
      this.selfAssessedRequirements = requirements;
    });
  }


  getJobMatchingScore(professionPreview: ProfessionPreview | ProfessionDetails): number {

    if(this.selfAssessedRequirements.length === 0) {
      return 0;
    }

    let countGood = 0;
    let countBad = 0;

    const allUserSelfAssessedRequirements: number[] = [];
    for(let i = 0; i < this.selfAssessedRequirements.length; i++) {
      allUserSelfAssessedRequirements.push(...this.selfAssessedRequirements[i].reqIds);
    }

    for (let selfAssessedRequirement of allUserSelfAssessedRequirements) {
      if (professionPreview.requirements.includes(selfAssessedRequirement)) {
        countGood++;
      } else {
        countBad++;
      }
    }

    if(countGood + countBad === 0) {
      return 1;
    }

    let score = countGood / (countGood + countBad);

    if(score < 0.33) {
      return 1
    } else if(score < 0.66) {
      return 2
    } else {
      return 3
    }

  }

}
